import Global from '../../../Services/Common/Global';
import { M_NOT_BASIC_Schema } from './M_NOT_BASIC_Schema';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../util';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasicR1, params);
  }, successOptions);
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic02R1, params);
  }, successOptions);
};

/** 안전보건경영방침 목록 */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_Schema.mapper.search3,
      context
    );
    return apiRequest(
      'post',
      Global.urls.PolicyAndGoals.getPolBasic01R2,
      params
    );
  }, successOptions);
};

/** 비상대응메뉴얼 목록 */
export const useSearch5 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_Schema.mapper.search5,
      context
    );
    return apiRequest(
      'post',
      Global.urls.EmergencyManual.getEmrBasic01R1,
      params
    );
  }, successOptions);
};
